/* ============================================================
   REGINA – Geschmacksprofil: Punkte-Skala erzeugen
   assets/section-product-tasting-notes.js
   ------------------------------------------------------------
   Erzeugt 5 Punkte pro Zeile und füllt sie entsprechend dem
   Wert (1-5) aus dem data-value-Attribut.
   ============================================================ */
(function () {
  document.querySelectorAll('.p-tdot-row').forEach(function (row) {
    var value = Math.round(parseFloat(row.dataset.value) || 3);
    value = Math.max(0, Math.min(5, value));
    var dotsWrap = row.querySelector('[data-dots]');
    if (!dotsWrap) return;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="' + (i <= value ? 'filled' : '') + '"></span>';
    }
    dotsWrap.innerHTML = html;
  });
})();
